__turbopack_context__.v({
  "marker": "F2-QTW_marker",
  "markerContainer": "F2-QTW_markerContainer",
  "tooltipButton": "F2-QTW_tooltipButton",
  "tooltipContent": "F2-QTW_tooltipContent",
  "tooltipDivider": "F2-QTW_tooltipDivider",
});
